import React, { useEffect, useState, useCallback } from "react";
import { Card } from "react-bootstrap";
import { getAllStories } from "../../../../api/summaryReport";

const DEFAULT_INFO = [
    { label: "Sprint Name", value: "" },
    { label: "Release Start Date", value: "" },
    { label: "Release End Date", value: "" },
    { label: "Release Cycle", value: "" },
    { label: "Assignees", value: "" },
    { label: "Total Stories", value: "" },
    { label: "Estimated Effort", value: "" },
];

const SprintInfo = () => {
    const token = localStorage.getItem("token");
    const [info, setInfo] = useState(DEFAULT_INFO);


    const fetchSprintInfo = useCallback(async () => {
        try {
            const res = await getAllStories(token);
            const stories = res.data;

            const today = new Date();

            // get stories with sprint
            const sprintStories = stories.filter((s) => s.sprint);

    
            const activeSprintStories = sprintStories.filter((story) => {
                const start = new Date(story.sprint.startDate);
                const end = new Date(story.sprint.endDate);
                end.setHours(23, 59, 59, 999);
                return today >= start && today <= end;
            });

            
            if (activeSprintStories.length === 0) return;

            const sprint = activeSprintStories[0].sprint;

            // release cycle
            const start = new Date(sprint.startDate);
            const end = new Date(sprint.endDate);
            

            const releaseCycle =
                Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

            
            const assignedItems = activeSprintStories.length;

            // unique assignees
            const assigneeSet = new Set();
            activeSprintStories.forEach((story) => {
                story.storyUsers?.forEach((u) => assigneeSet.add(u.user.id));
            });

            const assignees = assigneeSet.size;

            // estimated effort
            const estimatedEffort = activeSprintStories.reduce(
                (sum, story) => sum + (story.storyPoints || 0),
                0
            );

            setInfo([
                { label: "Sprint Name", value: sprint.sprintName },
                { label: "Release Start Date", value: sprint.startDate },
                { label: "Release End Date", value: sprint.endDate },
                { label: "Release Cycle", value: releaseCycle + " Days" },
                { label: "Assignees", value: assignees },
                { label: "Total Stories", value: assignedItems },
                { label: "Estimated Effort", value: estimatedEffort },
            ]);
        } catch (error) {
            console.error("Error fetching sprint info", error);
        }
    }, [token]);

    useEffect(() => {
        fetchSprintInfo();
    }, [fetchSprintInfo]);

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body
                style={{
                    background: "#7a8794",
                    color: "#fff",
                }}
            >
                {info.map((item, index) => (
                    <div key={index} className="mb-3">
                        <div className="d-flex">
                            <span className="fw-semibold me-2">{item.label} :</span>
                            <span>{item.value}</span>
                        </div>

                        <hr className="border-light opacity-25 mt-2" />
                    </div>
                ))}
            </Card.Body>
        </Card>
    );
};

export default SprintInfo;